module.exports = __webpack_public_path__ + "img/graph.01b7a152.png";